<template>
    <div>
        <el-input readonly
                  v-model="showName"
                  :size="size"
                  :placeholder="placeholder">
            <el-button @click="openSelect" slot="append">{{buttonText}}</el-button>
        </el-input>
        <Modal
                v-model="showUser"
                :title="modalTitle"
                :width="width">
            <RadioGroup v-model="selectUser" style="width: 100%">
                <Input v-model="query.name" style="width: 200px" clearable  placeholder="请输入姓名" ></Input>
                <Input v-model="query.username" style="width: 200px;margin-left: 5px" clearable  placeholder="请输入用户名" ></Input>
                <Input v-model="query.phone" style="width: 200px;margin-left: 5px" clearable  placeholder="请输入手机号" ></Input>
                <Button type="primary" @click="searchUser" style="margin-left: 10px">查询</Button>
                <el-table
                        v-if="tableData!=null&&tableData.length>0"
                        :data="tableData"
                        size="mini"
                        border
                        stripe
                        @row-click="rowClick"
                        :header-row-style="()=>{return 'color: #5c6b77'}"
                        :header-cell-style="()=>{return 'background: #f8f8f9;line-height:35px'}"
                        style="width: 100%;margin-top: 10px">
                    <el-table-column prop="name"
                                     align="center"
                                     width="60"
                                     :show-overflow-tooltip="true"
                                     label="选择">
                        <template slot-scope="scope">
                            <Radio :label="scope.row.id">
                                <span></span>
                            </Radio>
                        </template>
                    </el-table-column>
                    <el-table-column prop="statusName"
                                     align="center"
                                     :show-overflow-tooltip="true"
                                     label="状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.loginFlag=='0'">正常</span>
                            <span v-else>锁定</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name"
                                     align="left"
                                     :show-overflow-tooltip="true"
                                     label="姓名">
                    </el-table-column>
                    <el-table-column prop="username"
                                     align="left"
                                     :show-overflow-tooltip="true"
                                     label="用户名">
                    </el-table-column>
                    <el-table-column prop="phone"
                                     align="left"
                                     :show-overflow-tooltip="true"
                                     label="手机号">
                    </el-table-column>
                    <el-table-column prop="role.roleName"
                                     align="center"
                                     :show-overflow-tooltip="true"
                                     label="角色">
                    </el-table-column>
                </el-table>
                <avue-empty v-else style="margin-top: 10px"></avue-empty>
            </RadioGroup>

            <div slot="footer">
                <Row>
                    <Col span="18">
                        <div style="display: flex;justify-content: flex-start;">
                            <Page v-if="count>0" style="margin-bottom: 10px" transfer @on-change="pageChange"
                                  :page-size="10"
                                  @on-page-size-change="sizeChange"
                                  :current="query.current"
                                  prev-text="上一页"
                                  next-text="下一页" :total="count" show-elevator show-total show-sizer/>
                        </div>
                    </Col>
                    <Col span="6">
                        <Button size="large" @click="okClear">清空</Button>
                        <Button type="primary" size="large" @click="okSelect">选择</Button>
                    </Col>
                </Row>
            </div>
        </Modal>
    </div>
</template>

<script>
    import appUtils from '@/utils/appUtils';
    import {getUser, pageUser} from '@/api/system/user'

    export default {
        name: 'select-user',
        props: {
            //值
            value: {},
            //显示姓名
            name: {},
            //展位信息
            placeholder: {
                default:'请选择'
            },
            //弹出层标题
            modalTitle:{
                default:'选择用户'
            },
            //弹出层宽度
            width:{
                default:'800'
            },
            //表单尺寸
            size:{
                default:'small'
            },
            //按钮文字
            buttonText:{
                default:'选择'
            }
        },
        data () {
            return {
                //是否显示用户选择弹窗
                showUser: false,
                //列表数据
                tableData: []
                //数据总行数
                , count: 0
                // 用户查询条件
                , query: {
                    name: null,
                    username: null,
                    phone: null,
                    size: 10,
                    current: 1
                },
                //显示姓名
                showName: null,
                //已选择用户
                selectUser: null
            }
        },
        watch: {
            name () {
                this.showName = this.name
            },
            value(){
                if(this.value==null){
                    this.showName = null
                }else {
                    if(this.name==null){
                        this.getUser()
                    }
                }
            }
        },
        computed: {},
        methods: {
            /**
             * 根据ID获取用户
             */
            getUser(){
                getUser(this.value).then(res=>{
                    if(res.state && res.data!=null){
                        this.showName = res.data.name
                    }
                })
            },
            /**
             * 获取数据
             */
            getData () {
                this.selectUser = null
                let loading = appUtils.showLoading()
                pageUser(this.query).then(res => {
                    appUtils.hideLoading(loading)
                    if (res.state) {
                        this.tableData = res.data.records
                        this.count = res.data.total
                    } else {
                        appUtils.showError(res.msg)
                    }
                }).catch(err => {
                    appUtils.hideLoading(loading)
                })
            },
            /**
             * 页数发生改变
             */
            pageChange (val) {
                this.query.current = val
                this.getData()
            },
            /**
             * 每页显示条数发生改变
             */
            sizeChange (val) {
                this.query.size = val
                this.query.current = 1
                this.getData()
            },
            /**
             * 打开选择用户
             */
            openSelect () {
                this.showUser = true
                this.getData()
            },
            /**
             * 确认选择用户
             */
            okSelect () {
                this.$emit('input', this.selectUser)
                if (this.selectUser != null) {
                    let staff = this.tableData.filter(item => item.id == this.selectUser)
                    this.showName = staff[0].name
                } else {
                    this.showName = null
                }
                this.showUser = false
            },
            /**
             * 清空选择用户
             */
            okClear () {
                this.selectUser = null
                this.$emit('input', this.selectUser)
                this.showName = null
                this.showUser = false
            },
            searchUser(){
                this.query.current = 1
                this.getData()
            },
            /**
             * 单元格点击事件
             * @param row
             * @param column
             * @param event
             */
            rowClick(row, column, event){
                this.selectUser =  row.id
            }
        },
        mounted () {

        },
    }
</script>
